import WebpackerReact from 'webpacker-react'
import EmbedLauncher from '../application/components/embed/EmbedLauncher'
import EmbedOverlay from '../application/components/embed/EmbedOverlay'

WebpackerReact.setup({
  EmbedLauncher,
  EmbedOverlay,
})
